import toggleSideBar from './sidebarToggle'
import toggleSearchBar from './searchToggle'
import {combineReducers} from 'redux'

const allReducer=combineReducers({
    toggleSideBar,
    toggleSearchBar
});
export default allReducer; 